import Icon from "components/shared/Icon";
import Link from "components/shared/Link";

const mainClass = "syndicated-navigation__chrome__links__container";

const ChromeLinks = ({ brand = "", elements = [], mobileIcon = "" }) => {
	if (!elements.length) {
		return null;
	}

	return elements.map((element, key) => (
		<div className={`${mainClass} ${mainClass}--${brand}`} key={key}>
			{element.link && (
				<Link className={`${mainClass}__link`} {...element.link} />
			)}
			{element.descriptions?.[0] && (
				<>
					{mobileIcon && <Icon icon={mobileIcon} />}
					<span
						dangerouslySetInnerHTML={{ __html: element.descriptions[0].title }}
						className={`${mainClass}__description`}
					/>
				</>
			)}
		</div>
	));
};

export default ChromeLinks;
